var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9336",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1016"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 615",
    d: "M227.633 354.8h-3.4l.772-4.9h1.852z",
    transform: "translate(-215.935 -336.772)",
    style: {
      fill: "#f7cc19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 616",
    d: "M219 296.066a2.037 2.037 0 1 0-2.037 2.037 2.037 2.037 0 0 0 2.037-2.037",
    transform: "translate(-206.963 -282.938)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 617",
    d: "M16.5 84.851H3.248a3.248 3.248 0 0 1 0-6.5H16.5a3.248 3.248 0 0 1 0 6.5M3.248 79.459a2.144 2.144 0 0 0 0 4.287H16.5a2.144 2.144 0 0 0 0-4.287z",
    transform: "translate(.126 -75.128)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 645",
    transform: "translate(3.709 3.227)",
    style: {
      fill: "#fa9700"
    },
    d: "M0 0h12.581v1.104H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 618",
    d: "M112.13 226.218H99.649a6.242 6.242 0 0 0 .238 1.1h12a6.242 6.242 0 0 0 .238-1.1",
    transform: "translate(-95.89 -217.599)",
    style: {
      fill: "#fa9700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 619",
    d: "M119.083 39.312a5.741 5.741 0 0 1-5.741-5.741v-6.482h11.483v6.482a5.741 5.741 0 0 1-5.741 5.741",
    transform: "translate(-109.083 -25.731)",
    style: {
      fill: "#f7cc19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 620",
    d: "M135.7 72.678h-.583a.253.253 0 0 1-.253-.253v-5.542a.253.253 0 0 1 .253-.253h.583a.253.253 0 0 1 .253.253v5.542a.253.253 0 0 1-.253.253",
    transform: "translate(-129.817 -63.831)",
    style: {
      fill: "#f9dc3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 621",
    d: "M89.621 0H76.766a.672.672 0 0 0-.672.672V1.3a.672.672 0 0 0 .672.672h12.855a.672.672 0 0 0 .672-.672V.672A.672.672 0 0 0 89.621 0",
    transform: "translate(-73.193 .37)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 646",
    transform: "translate(4.366 .543)",
    style: {
      fill: "#fcc645"
    },
    d: "M0 0h1.766v1.593H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 647",
    transform: "translate(6.669 .543)",
    style: {
      fill: "#fcc645"
    },
    d: "M0 0h.734v1.593H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 622",
    d: "m187.686 106.329.656 1.33a.413.413 0 0 0 .311.226l1.467.213a.413.413 0 0 1 .229.7l-1.062 1.035a.413.413 0 0 0-.119.366l.251 1.461a.413.413 0 0 1-.6.435l-1.312-.69a.413.413 0 0 0-.384 0l-1.312.69a.413.413 0 0 1-.6-.435l.251-1.461a.413.413 0 0 0-.119-.366l-1.062-1.035a.413.413 0 0 1 .229-.7l1.467-.213a.413.413 0 0 0 .311-.226l.656-1.33a.413.413 0 0 1 .741 0",
    transform: "translate(-177.316 -101.86)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 623",
    d: "M157.688 460.514h-5.433a1.667 1.667 0 0 0-1.667 1.667.8.8 0 0 0 .8.8h7.161a.8.8 0 0 0 .8-.8 1.667 1.667 0 0 0-1.667-1.667",
    transform: "translate(-144.972 -443.352)",
    style: {
      fill: "#fab100"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRanking);
export default __webpack_public_path__ + "static/media/icon_ranking.e8f7662d7ee8283240bb07cf3f443069.svg";
export { ForwardRef as ReactComponent };